import React from "react"
import { connect } from "react-redux"
import { Col, ListGroup, ListGroupItem, Row } from "reactstrap"

const Downloads = ({ downloads, isModal }) => {
  return (
    <div
      style={
        isModal ? {} : { maxHeight: "400px", overflow: "auto", width: "350px" }
      }
    >
      <ListGroup
        style={
          isModal
            ? {}
            : { maxHeight: "400px", overflow: "auto", width: "350px" }
        }
      >
        {downloads
          ?.filter(item => item?.url)
          ?.map(item => {
            return (
              <ListGroupItem key={item?.id}>
                <a href={item?.url} download style={{ color: "black" }}>
                  <Row>
                    <Col>{item?.name}</Col>
                    <Col xs="auto">
                      <i
                        className="bx bxs-check-circle font-size-20"
                        style={{ color: "green" }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <span style={{ fontSize: "10px" }}>
                        <i>{item?.created_at}</i>
                      </span>
                    </Col>
                  </Row>
                </a>
              </ListGroupItem>
            )
          })}
      </ListGroup>
    </div>
  )
}

const mapStateToProps = state => ({
  downloads: state.Downloads.downloads,
})

export default connect(mapStateToProps)(Downloads)
